<template>
  <div v-if="logo" class="tl-logo__wrapper">
    <a-image
      :url="companyLink"
      :image="logo"
      :width="150"
      :aspect-ratio="aspectRatios.thoughtLeadershipLogo"
    />
  </div>
</template>

<script>
import { aspectRatios } from 'enums/aspectRatios'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import mixins from '@/utils/mixins'

export default {
  name: 'AThoughtLeadershipLogo',
  mixins: [mixins.urlGenerators],
  props: {
    logo: propValidator([PROP_TYPES.OBJECT], false),
    company: propValidator([PROP_TYPES.OBJECT], false)
  },
  data() {
    return { aspectRatios }
  },
  computed: {
    companyLink() {
      if (!this.company || !this.company.IsActive) return null

      return this.generateCompanyUrl(this.company)
    }
  }
}
</script>

<style lang="scss" scoped>
.tl-logo {
  &__wrapper {
    width: 150px;
  }
}
</style>
